var React = require('react');

function CheckCircle (props) {
    return React.createElement("svg",props,React.createElement("g",null,React.createElement("path",{"d":"M16.659 8.134l-7.146 6.67-2.159-2.158c-.195-.195-.512-.195-.707 0s-.195.512 0 .707l2.5 2.5c.097.098.225.147.353.147.123 0 .245-.045.341-.134l7.5-7c.202-.188.212-.505.024-.707-.188-.202-.503-.213-.706-.025zM12 0c-6.617 0-12 5.383-12 12s5.383 12 12 12 12-5.383 12-12-5.383-12-12-12zm0 23c-6.065 0-11-4.935-11-11s4.935-11 11-11 11 4.935 11 11-4.935 11-11 11z"})));
}

CheckCircle.defaultProps = {"version":"1","width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = CheckCircle;

CheckCircle.default = CheckCircle;
